import { render, staticRenderFns } from "./AdminLoginForm.vue?vue&type=template&id=039ca644&lang=true"
import script from "./AdminLoginForm.vue?vue&type=script&lang=js"
export * from "./AdminLoginForm.vue?vue&type=script&lang=js"
import style0 from "./AdminLoginForm.vue?vue&type=style&index=0&id=039ca644&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports